var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "container-wrapper",
    {
      style: {
        marginTop: _vm.widget.options.topMargin + 20 + "px !important" || "",
        marginBottom: _vm.widget.options.bottomMargin + "px !important" || "",
      },
      attrs: {
        designer: _vm.designer,
        widget: _vm.widget,
        "parent-widget": _vm.parentWidget,
        "parent-list": _vm.parentList,
        "index-of-parent-list": _vm.indexOfParentList,
      },
    },
    [
      _c(
        "el-card",
        {
          key: _vm.widget.id,
          staticClass: "card-container",
          class: [
            _vm.selected ? "selected" : "",
            !!_vm.widget.options.folded ? "folded" : "",
            _vm.customClass,
          ],
          style: { width: _vm.widget.options.cardWidth + "!important" || "" },
          attrs: { shadow: _vm.widget.options.shadow },
          nativeOn: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.selectWidget(_vm.widget)
            },
          },
        },
        [
          _vm.widget.options.cardHeader
            ? _c(
                "div",
                {
                  staticClass: "header clear-fix pointer",
                  attrs: { slot: "header" },
                  on: { click: _vm.toggleCard },
                  slot: "header",
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.widget.options.label))]),
                  _vm._v(" "),
                  _vm.widget.options.showFold
                    ? _c("i", {
                        staticClass: "float-right",
                        class: [
                          !_vm.widget.options.folded
                            ? "el-icon-arrow-down"
                            : "el-icon-arrow-up",
                        ],
                      })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "draggable",
            _vm._b(
              {
                attrs: {
                  list: _vm.widget.widgetList,
                  handle: ".drag-handler",
                  move: _vm.checkContainerMove,
                },
                on: {
                  add: function (evt) {
                    return _vm.onContainerDragAdd(evt, _vm.widget.widgetList)
                  },
                  update: _vm.onContainerDragUpdate,
                },
              },
              "draggable",
              { group: "dragGroup", ghostClass: "ghost", animation: 200 },
              false
            ),
            [
              _c(
                "transition-group",
                {
                  staticClass: "form-widget-list",
                  attrs: { name: "fade", tag: "div" },
                },
                [
                  _vm._l(_vm.widget.widgetList, function (subWidget, swIdx) {
                    return [
                      "container" === subWidget.category
                        ? [
                            _c(subWidget.type + "-widget", {
                              key: subWidget.id,
                              tag: "component",
                              attrs: {
                                widget: subWidget,
                                designer: _vm.designer,
                                "parent-list": _vm.widget.widgetList,
                                "index-of-parent-list": swIdx,
                                "parent-widget": _vm.widget,
                              },
                            }),
                          ]
                        : [
                            _c(subWidget.type + "-widget", {
                              key: subWidget.id,
                              tag: "component",
                              attrs: {
                                field: subWidget,
                                designer: _vm.designer,
                                "parent-list": _vm.widget.widgetList,
                                "index-of-parent-list": swIdx,
                                "parent-widget": _vm.widget,
                                "design-state": true,
                              },
                            }),
                          ],
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }